import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { CadastroParcial, CadastroParcialFormData, ApiResponse } from '../types';

// Criar cadastro parcial
export const createCadastroParcial = async (cadastroData: CadastroParcialFormData, userId: string): Promise<ApiResponse<CadastroParcial>> => {
  try {
    const cadastro: Omit<CadastroParcial, 'id'> = {
      nomeCliente: cadastroData.clienteNome,
      observacoes: cadastroData.observacoes,
      codigoFuncionario: cadastroData.codigoFuncionario,
      dataHora: new Date(),
      userId,
      createdAt: new Date(),
      updatedAt: new Date()
    };

    const docRef = await addDoc(collection(db, 'cadastrosParciais'), {
      ...cadastro,
      dataHora: serverTimestamp(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    return {
      success: true,
      data: { ...cadastro, id: docRef.id },
      id: docRef.id
    };
  } catch (error) {
    console.error('Erro ao criar cadastro parcial:', error);
    return {
      success: false,
      error: 'Erro ao criar cadastro parcial'
    };
  }
};

// Buscar cadastros parciais
export const getCadastrosParciais = async (userId: string): Promise<ApiResponse<CadastroParcial[]>> => {
  try {
    const q = query(
      collection(db, 'cadastrosParciais'),
      where('userId', '==', userId),
      orderBy('dataHora', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    const cadastros: CadastroParcial[] = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      dataHora: doc.data().dataHora?.toDate(),
      createdAt: doc.data().createdAt?.toDate(),
      updatedAt: doc.data().updatedAt?.toDate()
    } as CadastroParcial));

    return {
      success: true,
      data: cadastros
    };
  } catch (error) {
    console.error('Erro ao buscar cadastros parciais:', error);
    return {
      success: false,
      error: 'Erro ao buscar cadastros parciais'
    };
  }
};

// Buscar cadastros parciais por funcionário
export const getCadastrosParciaisByFuncionario = async (codigoFuncionario: string, userId: string): Promise<ApiResponse<CadastroParcial[]>> => {
  try {
    const q = query(
      collection(db, 'cadastrosParciais'),
      where('userId', '==', userId),
      where('codigoFuncionario', '==', codigoFuncionario),
      orderBy('dataHora', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    const cadastros: CadastroParcial[] = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      dataHora: doc.data().dataHora?.toDate(),
      createdAt: doc.data().createdAt?.toDate(),
      updatedAt: doc.data().updatedAt?.toDate()
    } as CadastroParcial));

    return {
      success: true,
      data: cadastros
    };
  } catch (error) {
    console.error('Erro ao buscar cadastros parciais por funcionário:', error);
    return {
      success: false,
      error: 'Erro ao buscar cadastros parciais'
    };
  }
};

// Atualizar cadastro parcial
export const updateCadastroParcial = async (id: string, updates: Partial<CadastroParcial>): Promise<ApiResponse<void>> => {
  try {
    const cadastroRef = doc(db, 'cadastrosParciais', id);
    await updateDoc(cadastroRef, {
      ...updates,
      updatedAt: serverTimestamp()
    });

    return {
      success: true
    };
  } catch (error) {
    console.error('Erro ao atualizar cadastro parcial:', error);
    return {
      success: false,
      error: 'Erro ao atualizar cadastro parcial'
    };
  }
};

// Deletar cadastro parcial
export const deleteCadastroParcial = async (id: string): Promise<ApiResponse<void>> => {
  try {
    await deleteDoc(doc(db, 'cadastrosParciais', id));
    return {
      success: true
    };
  } catch (error) {
    console.error('Erro ao deletar cadastro parcial:', error);
    return {
      success: false,
      error: 'Erro ao deletar cadastro parcial'
    };
  }
};
